import { Breadcrumbs, Card, Container, Flex } from '@teko/ds-desktop';
import { NoProductsFound } from '@teko/teko-ecommerce';
import { LazyComponent } from 'components/LazyComponent';
import { NotFoundProductLayout } from 'components/ProductDetail/styles';
import { useProductDetailState } from 'contexts';
import { t } from 'i18n';
import { Box } from 'reflexbox';
import { ProductDescription } from './NewProductDescription';

export const NewDetailPage = () => {
  const { product, breadcrumbs } = useProductDetailState();

  if (!product) {
    return (
      <NotFoundProductLayout>
        <NoProductsFound show text={t('Không tìm thấy sản phẩm')} />
      </NotFoundProductLayout>
    );
  }

  return (
    <Container marginBottom="s16">
      <Breadcrumbs breadcrumbs={breadcrumbs || []} />
      <Card style={{ padding: '24px' }}>Product main content</Card>
      <LazyComponent>
        <Flex gap="s16" marginTop="s16" align="start">
          <Box width="68.5%">
            <Card>
              <ProductDescription
                tabTitle={[t('Thông số kỹ thuật'), t('Chi tiết sản phẩm')]}
                buttonType="ghost"
              />
            </Card>
          </Box>
          <Box width="calc(100% - 68.5% - 16px)">
            <Card>Related news</Card>
            <Card marginTop="s16">Related videos</Card>
          </Box>
        </Flex>
      </LazyComponent>
      <LazyComponent>
        <Card marginTop="s16">Product review</Card>
      </LazyComponent>
      <LazyComponent>
        <Card marginTop="s16">Q&A</Card>
      </LazyComponent>
      <LazyComponent>
        <Card marginTop="s16">Related products</Card>
      </LazyComponent>
    </Container>
  );
};
